import { render, staticRenderFns } from "./InputfieldNotes.vue?vue&type=template&id=016d1771&scoped=true&"
import script from "./InputfieldNotes.vue?vue&type=script&lang=js&"
export * from "./InputfieldNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d1771",
  null
  
)

export default component.exports